var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInCarNavigationSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3818359,2c-0.4042969,0-0.8095703,0.0957031-1.1708984,0.2763672L3.2353516,13.7646484 C2.4736328,14.1464844,2,14.9121094,2,15.7636719C2,16.9970703,3.0029297,18,4.2363281,18H14v9.7636719 C14,28.9970703,15.0029297,30,16.2363281,30c0.8515625,0,1.6171875-0.4736328,2-1.2363281L29.7236328,5.7890625 C29.9042969,5.4277344,30,5.0224609,30,4.6181641C30,3.1748047,28.8251953,2,27.3818359,2z M27.9345703,4.8945312 L16.4482422,27.8681641C16.3476562,28.0664062,16,27.9833984,16,27.7636719V18c0-1.1025391-0.8974609-2-2-2H4.2363281 C4.1064453,16,4,15.8935547,4,15.7636719c0-0.0898438,0.0507812-0.1708984,0.1308594-0.2109375L27.1054688,4.0654297 C27.1904297,4.0224609,27.2861328,4,27.3818359,4C27.7226562,4,28,4.2773438,28,4.6181641 C28,4.7138672,27.9775391,4.8095703,27.9345703,4.8945312z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInCarNavigationSmall);
export default __webpack_public_path__ + "static/media/in-car-navigation--small.70836421d40727075d0c4412c8f54e5c.svg";
export { ForwardRef as ReactComponent };